﻿import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './common/auth.service';
import { currentUserMenuValue } from './common/constants/auth-keys';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

        let hasPermission: boolean = false;
        if (!route.children[0]['data']['menuValue'] || route.children[0]['data']['menuValue'][0] !== "") {
            let menuValue = localStorage.getItem(currentUserMenuValue);
            if (!menuValue) {
                if (state.url !== '' && state.url !== '/') {
                    this.authService.redirectUrl = state.url;
                    this.authService.logoutMessage = "You are not logged in";
                }
                this.authService.logout();
                return false;
            }
            let menuArray = menuValue.split(",");
            hasPermission = (route.children[0]['data']['menuValue'] && route.children[0]['data']['menuValue'].some(r => menuArray.indexOf(r) >= 0));
        }
        else {
            hasPermission = true;
        }
        if (this.authService.isLoggedIn && hasPermission) {
            return true;
        }
        if (!this.authService.isLoggedIn) {
            if (state.url !== '' && state.url !== '/') {
                this.authService.redirectUrl = state.url;
                this.authService.logoutMessage = "You are not logged in";
            }
            this.authService.logout();
        }
        else {
            this.router.navigate(['/']);
        }
        return false;        
    }    
}
